@if(!hideHeader){
<header class="fixed top-0 left-0 right-0 z-50 header-safe shadow-sm"
  [ngClass]="{'metro-header-light': !isDarkMode, 'metro-header-dark': isDarkMode}">
  <div class="container mx-auto px-6 flex justify-between items-center">
    <!-- Logo a la izquierda -->
    <div class="flex items-center">
      <img [src]="logoSrc" alt="Wine Passport Logo" class="h-8 cursor-pointer" (click)="goToHome()">
    </div>

    <!-- Enlaces de autenticación a la derecha -->
    <div class="flex space-x-3 px-3">
      <a class="text-xs font-medium no-underline hover:underline cursor-pointer" (click)="login()" [ngClass]="{
          'metro-text-dark': isDarkMode,
          'metro-text-light': !isDarkMode,
          'ml-auto': sommelierSlug === null
        }">
        {{'::Login'| abpLocalization}}
      </a>
      @if (showRegisterButton) {
      <a class="text-xs font-medium no-underline hover:underline cursor-pointer"
        [ngClass]="{'metro-text-dark': isDarkMode, 'metro-text-light': !isDarkMode}" (click)="openModalRegister()">
        {{'::Register'| abpLocalization}}
      </a>}
    </div>
  </div>
</header>
}

<app-metro-modal 
  [isOpen]="showRegisterClientModal" 
  [title]="registerStep === 'form' ? ('::CreateAccount' | abpLocalization) : ''"
  (close)="showRegisterClientModal = false" 
  [closeOnConfirm]="false" 
  [showCloseIcon]="true" 
  (confirm)="onModalConfirm()"
  [confirmText]="'::CreateAccount'"
  [showFooter]="registerStep === 'form'"
  [showHeader]="registerStep === 'form'"
>
  @if (showRegisterClientModal) {
    @if (registerStep === 'options') {
      <app-register-options 
        [slug]="sommelierSlug" 
        (continueWithEmail)="registerStep = 'form'">
      </app-register-options>
    } @else {
      <app-client-register-form 
        [slug]="sommelierSlug" 
        (clientSubmitted)="onClientSubmit($event)"
        (saved)="handleClientSaved()" 
        (cancelled)="onClientCancel()">
      </app-client-register-form>
      
    }
  }
</app-metro-modal>